module.exports = __webpack_public_path__ + "img/ic-barchart-grey.aadd59f4.svg";